import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'

import authReset from '../../lib/authReset'
import authSendWelcomeMail from '../../lib/authSendWelcomeMail'

export function getName(){
  return 'newsAddress'
}

export function getTableColumns(o,item){

  var lang = o.store('lang')

  var columns = [
    {
      id: 'email',
      value: item.email,
      type: o.type.text,
    },
    {
      id: 'lang',
      value: item.lang,
      type: o.type.text,
    },
    {
      id: 'unsubscribe',
      value: item.unsubscribe,
      type: o.type.toggle,
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
    },
  ]

  return columns

}

export function getTableData(o){

  var data =
    _.map(

      o.data.newsAddress,

      function(item){

        var model = o.model.newsAddress
        var columns = model.getTableColumns(o,item)

        var click =
          function(e){
            o.edit.set(item,model)
          }

        return {

          columns: columns,
          click: click,

        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  if(!item){
    var item = {}
  }

  var fields = [
    {
      id: 'email',
      value: item.email,
      type: 'text',
      edit: true,
    },
    {
      id: 'unsubscribe',
      value: item.unsubscribe,
      type: 'toggle',
      edit: true,
    },
    {
      id: 'lang',
      value: item.lang,
      type: 'text',
      edit: true,
    },
  ]

  return fields

}

export function insertForm(o,done){

}

export function remove(o,id,done){

  var data = o.data.newsAddress
  var collection = 'newsAddress'

  documentRemove(o,data,id,collection,done)

}

export function insert(o,item,done){

  var data = o.data.newsAddress
  var collection = 'newsAddress'

  item.user = o.store('email')
  item.date = new Date()

  documentInsert(o,data,item,collection)

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.newsAddress
  var collection = 'newsAddress'

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/newsAddress/newsAddress.js